import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useInsertKeyHandler } from '@lmt/unicorn-shared/app/components/dictionaries/useInsertKeyHandler';
import React, { FC } from 'react';
import { useSubtenants } from '../../../features/subtenants/selectors';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { TableTitle } from '@lmt/unicorn-shared/app/components/common/table/TableTitle';
import { SubtenantsTable } from './components/SubtenantsTable';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

import tableStyles from '@lmt/unicorn-shared/app/components/common/table/TableTitle.module.scss';
import PlusIcon from '@lmt/unicorn-shared/app/icons/plus-blue.svg?react';
import { useEventCallback } from '@mui/material';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';

export const SubtenantList: FC = () => {
  const i18next = useScopedTranslation('subtenants.list');
  const forms = useGlobalForms();
  const claims = useClaims();

  const subtenants = useSubtenants();

  const openCreate = useEventCallback(() => {
    if (!claims.permissions.createSubtenant) return;
    forms.openSubtenantCreating();
  });

  const openEdit = useEventCallback((id: number) =>
    forms.openSubtenantEditing(id),
  );

  useInsertKeyHandler(openCreate);

  return (
    <div
      className={tableStyles.pageContainer}
      data-test-id="table-page-container"
    >
      <div className={tableStyles.tableToolbar}>
        <TableTitle title={i18next.t('title')} count={subtenants.length} />
        {claims.permissions.createSubtenant && (
          <Button
            testId="plus-button"
            title={i18next.t('add_button')}
            color={ButtonColor.Primary}
            onClick={openCreate}
            iconComponent={<PlusIcon />}
          />
        )}
      </div>
      <div className={tableStyles.tableContainer}>
        <SubtenantsTable
          data={subtenants}
          noResults={false}
          onEdit={openEdit}
        />
      </div>
    </div>
  );
};
